import React from "react";
import { COMPANY } from "@/data/site";

export const LegalLayout = ({ title, updated, children }) => (
  <div>
    <section className="relative overflow-hidden bg-[#0A1128] pt-36 pb-16 text-white md:pt-44 md:pb-20">
      <div className="noise" />
      <div className="container-x relative">
        <p className="font-display text-xs uppercase tracking-[0.25em] text-[#4b6bd6]">Legal</p>
        <h1 className="mt-5 font-display text-4xl font-bold uppercase leading-none tracking-tighter md:text-6xl">
          {title}
        </h1>
        {updated && <p className="mt-6 text-sm text-slate-400">Last updated: {updated} &middot; Version 1.0</p>}
      </div>
    </section>
    <section className="container-x py-16 md:py-24">
      <div className="legal-prose max-w-3xl">{children}</div>
    </section>
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="mt-12 font-display text-2xl font-medium uppercase tracking-tight text-[#0A1128] first:mt-0 md:text-3xl">
    {children}
  </h2>
);

export const P = ({ children }) => <p className="mt-4 text-base leading-relaxed text-slate-600">{children}</p>;

export const UL = ({ items }) => (
  <ul className="mt-4 space-y-2">
    {items.map((it, i) => (
      <li key={i} className="flex gap-3 text-base leading-relaxed text-slate-600">
        <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-[#1D4ED8]" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

export const PLACEHOLDER = {
  controller: COMPANY.name,
  address: COMPANY.registeredAddress,
  email: COMPANY.email,
  phone: COMPANY.phone,
};
